export default "__VITE_ASSET__8ba721c6__"